import script from "./SliderInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SliderInput.vue?vue&type=script&setup=true&lang=ts"

import "./SliderInput.vue?vue&type=style&index=0&id=17cb2f82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17cb2f82"]])

export default __exports__